(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDetailController', MoneyTransferLogDetailController);

    MoneyTransferLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDetailController($scope, $rootScope, $stateParams, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;

        var unsubscribe = $rootScope.$on('tikonApp:moneyTransferLogUpdate', function (event, result) {
            vm.moneyTransferLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
